import CryptoJS from 'crypto-js';
import { CryptoService } from './cryptoService';

const ENCRYPT_MARKER = 'enc';
const ENCRYPT_VALUE = '1';
const LOGIN_ENCRYPT_STORAGE_KEY = 'TOPPION_LOGIN_ENCRYPT';

/** Khớp Encrypt:LoginEncrypt — mặc định false; chỉ bắt buộc enc=1 khi endpoint SSO config trả về true. */
let requireTokenEncrypt = false;

try {
  if (typeof localStorage !== 'undefined') {
    const stored = localStorage.getItem(LOGIN_ENCRYPT_STORAGE_KEY);
    if (stored === '0') requireTokenEncrypt = false;
    if (stored === '1') requireTokenEncrypt = true;
  }
} catch {
  // ignore
}

/** Gọi khi load SSO config / login (đồng bộ LoginEncrypt từ BE). */
export function setRequireTokenEncrypt(enabled: boolean) {
  requireTokenEncrypt = enabled === true;
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(LOGIN_ENCRYPT_STORAGE_KEY, requireTokenEncrypt ? '1' : '0');
    }
  } catch {
    // ignore
  }
}

export function getRequireTokenEncrypt() {
  return requireTokenEncrypt;
}

const ENCRYPTED_CLAIM_KEYS = [
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress',
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
  'nameid',
  'unique_name',
  'email',
  'role',
  'IdDepartment',
  'TenantID',
  'SuperAdmin',
  'sid',
] as const;

function tryDecryptClaim(value: unknown): string {
  if (typeof value !== 'string' || !value) return String(value ?? '');
  try {
    const plain = CryptoService.decryptAES(value);
    if (plain) return plain;
  } catch {
    // fallback Base64 .NET
  }
  try {
    const key = CryptoJS.enc.Utf8.parse('12345678901234567890123456789012');
    const iv = CryptoJS.enc.Utf8.parse('1234567890123456');
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Base64.parse(value) } as CryptoJS.lib.CipherParams,
      key,
      { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 },
    );
    const plain = decrypted.toString(CryptoJS.enc.Utf8);
    return plain || value;
  } catch {
    return value;
  }
}

/**
 * Decode JWT payload (không verify signature).
 * LoginEncrypt=true → bắt buộc enc=1 (token plaintext cũ → null).
 * Có enc=1 → giải mã AES các claim user.
 */
export function parseJwtPayload(token: string | null): Record<string, any> | null {
  if (!token) return null;
  try {
    const base64Url = token.split('.')[1];
    
    if (!base64Url) return null;

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    
    const payload = JSON.parse(jsonPayload);
    
    if (!payload) return null;

    const hasEnc = payload[ENCRYPT_MARKER] === ENCRYPT_VALUE;

    console.log('hasEnc ==> ', hasEnc);

    console.log('requireTokenEncrypt ==> ', requireTokenEncrypt);

    // Khớp BE: LoginEncrypt bắt buộc token đã mã hóa
    if (requireTokenEncrypt && !hasEnc) {
      return null;
    }

    if (!hasEnc) {
      return payload;
    }

    const decrypted: Record<string, any> = { ...payload };
    for (const key of ENCRYPTED_CLAIM_KEYS) {
      if (key in decrypted) {
        decrypted[key] = tryDecryptClaim(decrypted[key]);
      }
    }
    delete decrypted[ENCRYPT_MARKER];
    return decrypted;
  } catch (err){
    return null;
  }
}

export function tokenClaimsFromPayload(payload: Record<string, any> | null) {
  if (!payload) return null;
  const roleRaw = payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
  return {
    id: payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'],
    name: payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'],
    email: payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'],
    roles: typeof roleRaw === 'string' ? roleRaw.split(',') : undefined,
    departmentId: payload['IdDepartment'],
    tenantId: payload['TenantID'],
    superAdmin: payload['SuperAdmin'] === 'true',
    jti: payload['jti'],
    exp: payload['exp'],
  };
}
